import { Store } from '../Store';
import { LehrerEnv } from '../../../env/LehrerEnv';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { RequestStoreHost } from '../RequestStore/RequestStoreHost';
import { RequestStoreLocation } from '../RequestStore/RequestStoreLocation';

export class UserStore {
  readonly store: Store;

  constructor(store) {
    this.store = store;
  }

  get userData() {
    return this.store.storeData.userData;
  }

  get session() {
    return this.userData.session;
  }

  get user() {
    return this.userData.user;
  }

  get isPremium(): boolean {
    return this.userData.user.premium > 0;
  }
}
